import { useNetdoc } from "./useNetdoc.js";
import { pstyle } from "./lib/pstyle.js";
import Header from "./components/Header.jsx";
import Home from "./components/Home.jsx";
import Article from "./components/Article.jsx";
import Course from "./components/Course.jsx";
import IndexPage from "./components/IndexPage.jsx";
import Tools from "./components/Tools.jsx";
import Tshoot from "./components/Tshoot.jsx";
import Xlate from "./components/Xlate.jsx";
import Compare from "./components/Compare.jsx";
import Diagrams from "./components/Diagrams.jsx";
import Graph from "./components/Graph.jsx";
import Revise from "./components/Revise.jsx";
import Certif from "./components/Certif.jsx";
import Auth from "./components/Auth.jsx";
import Search from "./components/Search.jsx";
import Toast from "./components/Toast.jsx";
import NotFound from "./components/NotFound.jsx";
import Profile from "./components/Profile.jsx";

export default function App() {
  const v = useNetdoc();
  return (
    <div style={pstyle("min-height:100vh; background:oklch(1 0 0); color:oklch(0.22 0.012 60); font-family:'IBM Plex Sans', Helvetica, sans-serif;")}>
      <a href="#main-content" className="nd-skip-link">Aller au contenu</a>
      <Header v={v} />
      <div id="main-content">
        {v.isHome && <Home v={v} />}
        {v.isArticle && <Article v={v} />}
        {v.isCourse && <Course v={v} />}
        {v.isIndex && <IndexPage v={v} />}
        {v.isTools && <Tools v={v} />}
        {v.isTshoot && <Tshoot v={v} />}
        {v.isXlate && <Xlate v={v} />}
        {v.isCompare && <Compare v={v} />}
        {v.isDiagrams && <Diagrams v={v} />}
        {v.isGraph && <Graph v={v} />}
        {v.isRevise && <Revise v={v} />}
        {v.isCertif && <Certif v={v} />}
        {v.isAuth && <Auth v={v} />}
        {v.isProfile && <Profile v={v} />}
        {v.isNotFound && <NotFound v={v} />}
      </div>
      <Search v={v} />
      <Toast v={v} />
    </div>
  );
}
